import {createContext} from 'react'

/** Dashboard inputs load on the first picker open; other surfaces keep a live list. */
export const EnvironmentsFetchPolicyContext = createContext<'live' | 'lazy' | 'disabled'>('live')
